import { composeBundles } from 'redux-bundler';

import accounts from './accounts';
import auth from './auth';
import availabilityZones from './availability_zones';
import bootScheduleRuns from './boot_schedule_runs';
import bootSchedules from './boot_schedules';
import chefPackages from './chef_packages';
import clientUserAssignments from './client_user_assignments';
import clients from './clients';
import dashboardStats from './dashboard_stats';
import deployNotification from './deploy_notification';
import deployProgress from './deploy_progress';
import directories from './directories';
import documentationPages from './documentation_pages';
import extraArgs from './extra-args';
import facilities from './facilities';
import facilityAccessKeys from './facility_access_keys';
import fileUploadDestinations from './file_upload_destinations';
import fileUploads from './file_uploads';
import fsxFileSystems from './fsx_file_systems';
import githubAppInstallations from './github_app_installations';
import groups from './groups';
import imagePipelines from './image_pipelines';
import images from './images';
import instanceTypes from './instance_types';
import invitations from './invitations';
import keypairs from './keypairs';
import licenses from './licenses';
import masquerades from './masquerades';
import otpCodes from './otp_codes';
import passwordChanges from './password_changes';
import platformActivities from './platform_activities';
import preferences from './preferences';
import pusher from './pusher';
import regions from './regions';
import roles from './roles';
import routes from './routes';
import securityGroups from './security_groups';
import splitTests from './split_tests';
import ssmParameters from './ssm_parameters';
import subnets from './subnets';
import teams from './teams';
import templates from './templates';
import users from './users';
import utils from './utils';
import vpcs from './vpcs';
import weka from './weka';
import wekaConfigurationUploads from './weka_configuration_uploads';
import workstationCreationGroups from './workstation_creation_groups';
import workstationEventFeedEntries from './workstation_event_feed_entries';
import workstationLogins from './workstation_logins';
import workstationStats from './workstation_stats';
import workstations from './workstations';

// import cache from '../utils/cache'

export default composeBundles(
  availabilityZones,
  accounts,
  bootScheduleRuns,
  bootSchedules,
  auth,
  facilityAccessKeys,
  chefPackages,
  clients,
  clientUserAssignments,
  dashboardStats,
  deployNotification,
  deployProgress,
  directories,
  documentationPages,
  extraArgs,
  facilities,
  fileUploads,
  fileUploadDestinations,
  githubAppInstallations,
  groups,
  imagePipelines,
  fsxFileSystems,
  images,
  instanceTypes,
  invitations,
  keypairs,
  licenses,
  masquerades,
  otpCodes,
  passwordChanges,
  platformActivities,
  preferences,
  pusher,
  regions,
  roles,
  routes,
  securityGroups,
  splitTests,
  ssmParameters,
  subnets,
  teams,
  templates,
  users,
  utils,
  vpcs,
  weka,
  wekaConfigurationUploads,
  workstationCreationGroups,
  workstationEventFeedEntries,
  workstations,
  workstationLogins,
  workstationStats,
);
